import React from 'react';
import { ClientsSlider } from 'src/components/ClientsSlider/ClientsSlider';
import { clsx } from 'clsx';

const DefaultTitle = () => {
  return (
    <div className={'flex flex-col gap-2.5 items-center justify-center'}>
      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="53"
          height="32"
          viewBox="0 0 53 32"
          fill="none"
        >
          <path
            d="M16.3688 -4.26488e-05C12.1871 -4.24677e-05 8.07498 1.67282 5.11808 4.65054C2.16117 7.62825 0.499999 11.6669 0.499999 15.878C0.499999 20.0892 2.16117 24.1278 5.11808 27.1055C8.07498 30.0832 12.1871 31.7561 16.3688 31.7561L16.3688 15.878L16.3688 -4.26488e-05Z"
            fill="#05050D"
          />
          <path
            d="M36.6299 0C45.3942 0.000141731 52.4989 7.10888 52.499 15.8779C52.499 24.6471 45.3943 31.7557 36.6299 31.7559C27.8654 31.7559 20.7598 24.6471 20.7598 15.8779C20.7599 7.10879 27.8654 0 36.6299 0ZM36.5898 9.37109C33.0046 9.37109 30.0977 12.2798 30.0977 15.8672C30.0977 19.4545 33.0046 22.3623 36.5898 22.3623C40.175 22.3623 43.081 19.4545 43.0811 15.8672C43.0811 12.2798 40.1751 9.37113 36.5898 9.37109Z"
            fill="#05050D"
          />
        </svg>
      </div>
      <div>
        <p className={'uppercase text-[1.375rem] text-black font-bold'}>
          Welcome to CoSupport AI Hub!
        </p>
      </div>
    </div>
  );
};

interface AuthWrapperProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  privacyHidden?: boolean;
  sliderHidden?: boolean;
}

export const AuthWrapper = ({
  title = '',
  children,
  className = '',
  privacyHidden = false,
  sliderHidden = false,
}: AuthWrapperProps) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center w-full h-full min-h-screen gap-[25px] pt-[50px] rounded-sm-5 bg-[linear-gradient(23deg,#F6FFE8_0.5%,#E2FFEC_25.51%,#E2F9FF_58.74%,#E5F1FE_98.59%)]',
        privacyHidden ? 'pb-[60px]' : 'pb-[24px]',
        className,
      )}
    >
      {title || <DefaultTitle />}
      {children}
      {!sliderHidden && <ClientsSlider />}
      {!privacyHidden && (
        <div className={'text-center text-xs text-ebony_opacity_40 font-medium mt-[19px]'}>
          <p>
            CoSupport AI © {new Date().getFullYear()}.{' '}
            <a
              className="underline"
              href="https://cosupport.ai/privacy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>{' '}
            &{' '}
            <a
              className="underline"
              href="https://cosupport.ai/terms-of-services"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
          </p>
        </div>
      )}
    </div>
  );
};
